var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidebarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70711 8.70711C7.09763 8.31658 7.09763 7.68342 6.70711 7.29289C6.31658 6.90237 5.68342 6.90237 5.29289 7.29289L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071L5.29289 16.7071C5.68342 17.0976 6.31658 17.0976 6.70711 16.7071C7.09763 16.3166 7.09763 15.6834 6.70711 15.2929L4.41421 13H19.5858L17.2929 15.2929C16.9024 15.6834 16.9024 16.3166 17.2929 16.7071C17.6834 17.0976 18.3166 17.0976 18.7071 16.7071L22.7 12.7142C23.0945 12.3197 23.0944 11.6802 22.7 11.2858L18.7071 7.29289C18.3166 6.90237 17.6834 6.90237 17.2929 7.29289C16.9024 7.68342 16.9024 8.31658 17.2929 8.70711L19.5858 11H4.41421L6.70711 8.70711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarOpen);
export default __webpack_public_path__ + "static/media/ic_sidebar-open.3c6710491a26d1af36d5e3ff1027be87.svg";
export { ForwardRef as ReactComponent };